import { ValidateStep } from 'utils/Validations'

const EventForm = {
  el: {
    root: document.querySelector<HTMLElement>('.event-form-block'),
    steps: document.querySelectorAll<HTMLElement>('.event-form-block__step'),
    nextButton: document.querySelector<HTMLAnchorElement>('.event-form__next'),
    backButton: document.querySelector<HTMLAnchorElement>('.event-form__back'),
    messageTempData: document.querySelector<HTMLElement>('.service-form__temp-data'),
  },

  init() {
    if (this.el.root) {
      this.handleStepButtons()
      this.handleTempDataMessage(true)
    }
  },

  handleTempDataMessage(hasTimeout: boolean) {
    if (this.el.messageTempData) {
      if (this.el.messageTempData.style.display == 'block') {
        if (hasTimeout) {
          setTimeout(() => {
            this.el.messageTempData.style.display = 'none'
          }, 10000)
        }
        else {
          this.el.messageTempData.style.display = 'none'
        }
      }
    }
  },

  handleStepButtons() {
    this.el.nextButton.addEventListener('click', (e: Event & { target: HTMLAnchorElement }) => {
      this.handleStepChange(e)
    })

    this.el.backButton.addEventListener('click', (e: Event & { target: HTMLAnchorElement }) => {
      this.handleStepChange(e, false)
    })
  },

  handleStepChange(event, next: boolean = true) {
    event.preventDefault()

    if (next) {
      if (ValidateStep(this.el.root.querySelector('.event-form-block__step[data-step="1"]'))) {
        this.stepChange(event)
      }
    }
    else {
      this.stepChange(event)
    }
  },

  stepChange(event) {
    this.removeActive()
    this.addActive(event.target.dataset.step)

    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  },

  addActive(step) {
    document.querySelector(`.event-form-block__step[data-step="${step}"]`).classList.add('active')
  },

  removeActive() {
    Array.prototype.forEach.call(this.el.steps, item => {
      item.classList.remove('active')
    })
  },

}

export default EventForm
